import { TdsFooter, TdsFooterGroup, TdsFooterItem } from '@scania/tegel-react';

const year = new Date().getFullYear();

export const TegelFooter = () => (
  <TdsFooter className="tegel-app-footer" modeVariant="primary">
    <div slot="end" className="tegel-app-footer-main-links">
      <TdsFooterGroup tdsListAriaLabel="Footer support links">
        <TdsFooterItem>
          <a href="mailto:devtools@scania.com">devtools@scania.com</a>
        </TdsFooterItem>
      </TdsFooterGroup>
    </div>

    <span slot="copyright">Copyright © {year} Scania CV AB</span>
  </TdsFooter>
);
